<div class="lv-browser-warning">
  <div class="lv-browser-warning-content">
    <div class="lv-browser-warning-headline">{{ 'BROWSER_WARNING.HEADLINE' | translate }}</div>
    <p class="lv-browser-warning-description"
       [innerHtml]="'BROWSER_WARNING.DESCRIPTION' | translate: {isMac: isMac}">
    </p>
  </div>
</div>

